import { useAuthStore } from "../../store/auth.store";
import { useEffect, useState } from "react";
import { PartnerApi } from "../../api/partner.api";
import { useProductsStore } from "../../store/products.store";
import { useProducts } from "../../hook/partner/product.partner.hook";
import number_format from "../../utils/number_format";
import { useTranslation } from "../../hooks/useTranslation";

export default function ProductsCatalog({ vendor_id, addProduct }) {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  const [vendorId, setVendor] = useState(vendor_id ?? 0);
  const [filteredYears, setFilteredYears] = useState([]);
  const [directory_id, setDir] = useState(0);
  const productsMutation = useProducts();
  const token = useAuthStore((state) => state.token);
  const products = useProductsStore((state) => state.products);

  useEffect(() => {
    if (token && vendorId) {
        setFilteredYears([]);
      productsMutation.mutate({ token, vendor_id: vendorId, directory_id });
    }
  }, [token, vendorId, directory_id]);

  const filterYears = [];

  if (vendorId && products && products.products?.length > 0) {
      products.products.map((p)=>{
          if (p.rnw_duration > 0) {
              if (!filterYears.includes(p.rnw_duration)) {
                  filterYears.push(p.rnw_duration);
              }
          }
      });

      filterYears.sort();



      if (filterYears.length > 0 && filteredYears.length == 0) {
          filterYears.map((y)=>{
              filteredYears.push(y);
          })
      }
  }
let filteredProducts = products && products.products?.length ? products.products : [];
    if (vendorId && products && filteredYears.length > 0) {
        filteredProducts = filteredProducts.filter(p=>{
            return filteredYears.includes(p.rnw_duration)
        })
    }

  return (
    <>
      {vendorId && products ? (
        <>
          <h3 className="pt-3">{products.name}</h3>
          {products.breadcrumbs?.length > 0 && (
            <div>
              <span
                className="badge badge-info badge-outline"
                onClick={() => setDir(0)}
                style={{ cursor: "pointer" }}
              >
                {products.vendor_name}
              </span>
              {products.breadcrumbs.map((b) => (
                <>
                  {" "}
                  &gt;{" "}
                  <span
                    className="badge badge-info badge-outline"
                    style={{ cursor: "pointer" }}
                    onClick={() => setDir(b.directory_id)}
                  >
                    {b.name}
                  </span>
                </>
              ))}
            </div>
          )}
          {products.subdirectories?.length > 0 && (
            <div className="pt-3">
              {products.subdirectories.map((s) => (
                <div>
                  <a
                    href="javascript:;"
                    onClick={() => setDir(s.dir_id)}
                    style={{
                      display: "block",
                      padding: "10px",
                      borderTop: "solid 1px #ddd",
                    }}
                  >
                    <span
                      className="badge badge-primary badge-outline"
                      style={{ float: "right" }}
                    >
                      {s.productCount}
                    </span>
                    {s.name}
                  </a>
                </div>
              ))}
            </div>
          )}
            {filterYears.length > 0 && (
                <div className={"d-flex gap-3 mt-3"}>
                    <div>Počet let: </div>
                    {
                        filterYears.map(filterYear => (
                            <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">
                                <span className="form-check-label text-gray-700 fs-6 fw-semibold ms-0 me-2">{filterYear/12}</span>
                                <input className="form-check-input" type="checkbox" checked={filteredYears.includes(filterYear)} value={filterYear} onChange={(e)=>{
                                    const val = parseInt(e.target.value);
                                    const checked = e.target.checked;
                                    if (checked && !filteredYears.includes(val)) {
                                        filteredYears.push(val)
                                        setFilteredYears([...filteredYears]);
                                        console.log([...filteredYears])
                                    } else if (!checked && filteredYears.includes(val)) {
                                        console.log(filteredYears.indexOf(val))
                                        filteredYears.splice(filteredYears.indexOf(val),1);
                                        setFilteredYears([...filteredYears]);
                                        console.log([...filteredYears])
                                    }
                                }} />
                            </label>
                        ))
                    }
                </div>
                )}
          {filteredProducts?.length > 0 && (
            <div className="pt-3">
              {filteredProducts.map((p) => (
                <div className="row" style={{ borderTop: "solid 1px #ddd" }}>
                  <div className="col-8">
                    <div style={{ padding: "10px" }}>
                      <a
                        href="javascript:;"
                        className="me-3"
                        onClick={() => addProduct(p.product_id)}
                      >
                        <strong>{p.name}</strong>
                      </a>
                      <div>
                        <span className="badge badge-secondary">{p.sku}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    {p.eu_price ? (
                      <div
                        style={{
                          padding: "10px",
                          textAlign: "right",
                        }}
                      >
                        {number_format(p.eu_price, 2, ",", ".")}&nbsp;
                        {p.currency}
                        {"discount" in p && parseInt(p.discount) > 0 && (
                          <div style={{ color: "#333", fontSize: "0.8em" }}>
                            -{p.discount}% ~{" "}
                            {number_format(
                              p.eu_price * ((100 - p.discount) / 100),
                              2,
                              ",",
                              "."
                            )}
                            &nbsp;
                            {p.currency}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        className="alert alert-danger m-3"
                        style={{ fontSize: "0.8em" }}
                      >
                        {t("products.priceNotSpecified")}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <>
          <h3>{t("products.selectVendor")}</h3>
          <div className="row">
            {user?.role
              .find((r) => r.role_id === "vendors")
              ?.val?.map((vendor) => (
                <div
                  className="col-3"
                  style={{ textAlign: "center" }}
                  key={vendor}
                >
                  <a
                    href="javascript:;"
                    onClick={() => setVendor(vendor.vendor_id)}
                  >
                    <img
                      className="mw-100"
                      style={{
                        aspectRatio: "1 / 1",
                        objectFit: "contain",
                        border: "solid 1px #ddd",
                        padding: "5px",
                        borderRadius: "10px",
                      }}
                      src={
                        PartnerApi.url +
                        "/vendor/" +
                        vendor.vendor_id +
                        "/logo.jpg"
                      }
                      alt={vendor.name}
                    />
                  </a>
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
}
